module.exports = __webpack_public_path__ + "media/images/ADC_logo_custom-28c4940725deb528b575e9c0cd4c97fa.png";